import restapp from '../api/restapp';

import {
  MODEL_OBJECT,
  MODEL_OBJECT_2,
} from './types';

const initialState = {
  vuexLayoutModelObject: {},
  getErrorLayout: null,
  updateErrorLayout: null,
  vuexIsLoadingLayout: false,
};

const actions = {
  getVuexLayoutModelObject({ commit }, { cv_id }) {
    console.log('****getVuexLayoutModelObject called: ' + cv_id);
    return restapp.getModObj(cv_id)
      .then(({ data }) => commit(MODEL_OBJECT, data))
      .catch(function (error) {
        if (error.response) {
          console.log(error)
        }
        else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        }
        else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error get', error.message);
        }
        console.log(error.config);
      });
  },

 

  updateVuexLayoutModelObject({ commit }, { cv_id, data_sent }) {
    console.log('*+*+*updatevuexLayoutModelObject called: ' + cv_id + '--> ' + data_sent);
    this.vuexIsLoadingLayout = true;
    
    console.log("Changement sur l'objet : " + data_sent);
    console.log(data_sent);
    
    return restapp.updateModObj(cv_id, data_sent)
      .then(({ data }) => commit(MODEL_OBJECT, data))
      .catch(function (error) {
        if (error.response) {
          console.log(error);
        }
        else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        }
        else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error update', error.message);
        }
        console.log(error.config);
      });
  },
     
};


const mutations = {
  [MODEL_OBJECT](state, resp) {
    console.log('Vuex sectionLayout [MODEL_OBJECT] : données envoyée à la mutation : ' + resp);
    state.vuexLayoutModelObject = resp;
  },
  [MODEL_OBJECT_2](state, struct) {
    // mutation dédiée au getter/setter (voir le composant SectionLayout.vue)
    // struc est un objet (python dict :-) ) contenant le champs et la valeur à updater sur l'objet vuexLayoutModelObject
    console.log('Vuex sectionLayout [MODEL_OBJECT_2] : données envoyée à la mutation 2 : ' + struct);
    console.log('****APR* ' + state.vuexLayoutModelObject[struct.field]);

    console.log('****AVT* ' + struct.resp);
    console.log('****AVT* ' + struct.resp);
    state.vuexLayoutModelObject[struct.field] = struct.resp;
    console.log('****APR* ' + state.vuexLayoutModelObject[struct.field]);
    
  },
};


export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};

